module.exports = __webpack_public_path__ + "static/vetement3-35848a689068108020ed11c99ce1c003.jpg";